export enum UserType {
  GUEST = "GUEST",
  SUBS = "SUBS",
}

export interface SubsUserData {
  userType: UserType.SUBS;
  id: number;
  universalUserUuid: string;
  email: string;
  name: string;
}

export interface GuestUserData {
  id: number;
  userType: UserType.GUEST;
  email: string;
}

export interface SessionUserData {
  userType: UserType;
  email: string;
  userData: SubsUserData | GuestUserData;
}
